<template>
    <div class="conflicts">

        <ConflictsMessages v-if="messagesData" :messages="messagesData"></ConflictsMessages>

        <div class="conflict" v-for="(conflict,index) in conflictsData">
            <div class="remote">
                {{ conflict.remote.label }}
            </div>
            <div class="local">
                <!--<select>
                    <option value=""></option>
                    <option v-for="localItem in conflict.local" :value="localItem.id">{{ localItem.label }} ({{ localItem.score }})</option>
                </select>-->
                <ConflictAutocompleter :choices="conflict.local" :creation="true" :autocompleter="true" :autocompleterURL="extra" :icon="itemsIcon" :labelAdd="labelAdd" :labelSearch="labelSearch" v-model="value[conflict.remote.id]"></ConflictAutocompleter>
            </div>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import {mapGetters} from 'vuex'

    import ConflictAutocompleter from '../ConflictAutocompleter'
    import ConflictsMessages from '../ConflictsMessages'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            ConflictAutocompleter,
            ConflictsMessages
        },
        computed: {

            ...mapGetters({
                currentStepData: 'Plugins/currentStepData'
            }),

            conflictsData(){
                return this.currentStepData.conflicts || null
            },
            messagesData(){
                return this.currentStepData.messages || null
            }
        },
        created: function () {

        },
        data() {
            return {

            }
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

        },
        name: 'Conflicts',
        props: {
            itemsIcon: {
                type: String,
                default: null
            },
            extra: {
                type: String,
                required: true
            },
            labelAdd: {
                type: String,
                default: "Nouveau"
            },
            labelSearch: {
                type: String,
                default: "Autre"
            },
            value: {
                type: [Array,Object],
                default(){
                    return {}
                }
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .conflicts{
        overflow: visible;
        height: 100%;

        .conflict{
            display: flex;
            flex-direction: row;

            .remote{
                flex: 1 1 100%;
                line-height: $form-elements-line-height;
            }

            .local{

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/plugins/formbuilder/elements/Conflicts.vue